export default __webpack_public_path__ + "static/media/tamaki.3e918bf4.webp";